 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import TOC from '@/components/toc'
 import FRONT2 from '@/components/front2'
 import ILLUSTRATION from '@/components/illustration'
 import PART1 from '@/components/part1'
 import DEDICATION1 from '@/components/dedication1'
 import CHAP1 from '@/components/chap1'
 import PART2 from '@/components/part2'
 import CHAP2 from '@/components/chap2'
 import POSTSCRIPT from '@/components/postscript'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/front2",
 			"name" : "front2",
 			"component" : FRONT2
 		},
 		{
 			"path" : "/illustration",
 			"name" : "illustration",
 			"component" : ILLUSTRATION
 		},
 		{
 			"path" : "/part1",
 			"name" : "part1",
 			"component" : PART1
 		},
 		{
 			"path" : "/dedication1",
 			"name" : "dedication1",
 			"component" : DEDICATION1
 		},
 		{
 			"path" : "/chap1",
 			"name" : "chap1",
 			"component" : CHAP1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js